import { Icon } from "PFComponents/icon";
import { ActivityPureCustomValue } from "PFTypes";

import css from "./content.module.scss";

type RolePositionFinalDataRowProps = {
  locations: string;
  languageValues?: ActivityPureCustomValue[] | null;
  languageDisplayAs?: string | null | false;
};

export const RolePositionFinalDataRow = ({
  locations,
  languageValues,
  languageDisplayAs
}: RolePositionFinalDataRowProps) => {
  const hasLanguages = !!languageValues?.length;

  return (
    <div className={css.finalDataRow}>
      {locations && (
        <span>
          <Icon name="location" size="sm" color="paletteWhite3" />
          <span>{locations}</span>
        </span>
      )}
      {hasLanguages && (
        <span>
          <span>{`${languageDisplayAs}: `}</span>
          <span>{languageValues?.map(({ text }) => text).join(", ")}</span>
        </span>
      )}
    </div>
  );
};
